

/**
 * Puts a popup box in the dead center of the screen.
 * Customise the appearance by changing the class of the various components
 */
vPopup = { }

vPopup.create = function vPopup_create( settings ) {
	
	if( typeof settings === 'string' )
		settings = { message: settings }
	
	settings = settings || { };
	for( var prop in vPopup.defaults ) {
		if( !settings.hasOwnProperty(prop) ) {
			settings[prop] = vPopup.defaults[prop];
		}
	}
	
	if( settings.title == null && settings.message == null ) {
		console.warn('vPopup: attempted to create an empty popup');
		return;
	}
	
	var oldOverlay = document.getElementsByClassName( settings.popupOverlayClass )[0];
	if( oldOverlay )
		oldOverlay.parentNode.removeChild( oldOverlay );
	
	var popupOverlay = document.createElement( 'div' );
	popupOverlay.className = settings.popupOverlayClass;
	
	var popupBox = document.createElement( 'div' );
	popupBox.className = settings.popupBoxClass;
	popupOverlay.appendChild( popupBox );
	
	if( settings.title != null ) {
		var popupTitle = document.createElement( 'div' );
		popupTitle.className = settings.popupTitleClass;
		popupTitle.innerHTML = settings.title;
		popupBox.appendChild( popupTitle );
	}
	
	if( settings.message != null ) {
		var popupMessage = document.createElement( 'div' );
		popupMessage.className = settings.popupMessageClass;
		popupMessage.innerHTML = settings.message;
		popupBox.appendChild( popupMessage );
	}
	
	if( settings.buttons != null && typeof settings.buttons === 'object' && settings.buttons.length > 0 ) {
		var popupButtonContainer = document.createElement( 'div' );
		popupButtonContainer.className = settings.popupButtonContainerClass;
		popupBox.appendChild( popupButtonContainer );
		
		for(var b=0; b<settings.buttons.length; b++ ) {
			var button = { };
			for(var prop in settings.buttons[b]) {
				button[prop] = settings.buttons[b][prop];
			}
			
			for(var prop in vPopup.buttonDefaults) {
				if( !button.hasOwnProperty(prop) ) {
					button[prop] = vPopup.buttonDefaults[prop];
				}
			}
			
			var popupButton = document.createElement( 'button' );
			popupButton.className = button.buttonClass;
			popupButton.innerHTML = button.text;
			if( button.action )
				popupButton.setAttribute('data-action', button.action);
			
			if( button.dismiss ) {
				button.callback = (function(buttonCallback) {
					return function( event ) {
						popupOverlay.parentNode.removeChild( popupOverlay );
						buttonCallback( event );
					}
				})((button.callback || function( event ) { }));
			}
			
			if( button.callback )
				popupButton.addEventListener('click', button.callback);
			
			popupButtonContainer.appendChild( popupButton );
		}
	}
	
	// finally: attach popup to document
	document.body.appendChild( popupOverlay );
	
	return popupOverlay;
}

vPopup.defaults = {
	title: null,
	message: null,
	popupOverlayClass: 			"vpopup-overlay",
	popupBoxClass: 				"vpopup-box",
	popupTitleClass:			"vpopup-title",
	popupMessageClass:			"vpopup-message",
	popupButtonContainerClass:	"vpopup-buttons",
	buttons: [
	    {
	    	text: "OK",
	    	action: "OK",
		    dismiss: true,
	    	callback: function() { },
	    	buttonClass: "vpopup-button vpopup-button-ok"
	    }
	]
}

vPopup.buttonDefaults = {
	text: "Close",
	action: null,
    dismiss: true,
	callback: function() { },
	buttonClass: "vpopup-button"
}

console.log("vpopup.js - loaded");
